module.exports = __webpack_public_path__ + "img/stortjarn_202110.3256707e.jpg";